import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const LocationItem = ({ data }) => {
    const payload = data.payload;
    let value = payload.value || {};
    value = (typeof value === 'string') ? JSON.parse(value) : value;

    const openMap = e => {
        const lat = value.latitude;
        const lng = value.longitude;

        window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank');
    }

    return (
        <ListItem onClick={openMap} button>
            <i className="material-icons">pin_drop</i>
            <ListItemText primary={payload.title} />
        </ListItem>
    );

}

export default LocationItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/Location.js